var render = function render(){var _vm=this,_c=_vm._self._c;return _c('H5Layout',{attrs:{"title":"角色管理","active":""}},[_c('ZRole')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }